module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("I’VE WRITTEN")]), _vm._v(" many novels, both published and unpublished, where I’ve gotten invaluable help from mentors and other writers. They’ve all been named specifically in previous acknowledgments, so I won’t repeat them here. Instead, some comments about Dreamspinner Press. I had a lovely experience with my first publisher, but when I discovered Dreamspinner Press, I found a home. I’ve learned and grown from the editing process, and I’ve now worked with some incredible Dreamspinner editors, most specifically the wonderful, patient, and supremely capable Dawn Johnson. My last several books have had thought-provoking, evocative covers by Aaron Anderson. And I always feel appreciated by office staff, editorial staff, publicity staff, and everyone else. I almost never contact anybody at Dreamspinner who doesn’t return my email within hours, if not minutes. And I believe Elizabeth North is the best publisher on the planet. I bless the day I discovered Dreamspinner Press/Harmony Ink Press. Their support, their encouragement, and their responsiveness make the sometimes-thankless task of writing novels worthwhile.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e718372","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0004.vue
// module id = 66
// module chunks = 0